import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import GiteOutlinedIcon from "@mui/icons-material/GiteOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { enqueueSnackbar } from "notistack";
import {
  _Client_Center_List,
  _Exiting_Messages,
  _List_Chat,
  _List_Chat_Messages,
  _Make_Count_Zero,
} from "../../DAL/Listing/Chat";
import GroupIcon from "@mui/icons-material/Group";
import Linkify from "react-linkify";
import { picBaseUrl } from "../../config/config";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { show_proper_words } from "../../utils/constant";
import moment from "moment";
import {
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
} from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useAdminContext } from "../../Hooks/AdminContext";
import { useUserData } from "../../Hooks/App_Context";
import DeleteConfirmation from "../../components/DeleteConfirmation";

export default function LiveChat({
  open,
  handleClose,
  selectChat,
  setSelectChat,
  sendMessagesLoader,
  setSendMessagesLoader,
  delLoading,
  setDelLoading,
  tabValue,
  setChatList,
  setUserList,
  setEndChat,
  setChats,
  userList,
  chatList,
  setTabValue,
  setOpenDelete,
  openDelete,
  isChatInitiated,
  setIsChatInitiated,
  isChatSelected,
  setIsChatSelected,
  setMessageId,
  messageId,
}) {
  const chatEndRef = useRef(null);
  const {
    setUnreadMessageCount,
    isNewMessage,
    notificationMessage,
    setisNewMessage,
  } = useUserData();
  const { socket } = useAdminContext();
  const [isDelete, setIsDelete] = useState(null);
  const [customerLoader, setCustomerLoader] = useState(false);
  const [messages, setMessage] = useState("");
  const [chatLoader, setChatLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [edit, setEdit] = useState(null);
  const [backButtonLoader, setBackButtonLoader] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);

  // Handles the click event on a message and sets the anchor element for the menu and the selected message.
  const handleClick = (event, message) => {
    setAnchorEl(event.currentTarget);
    setSelectedMessage(message); // Track which message this menu belongs to
  };

  // Closes the menu and resets the selected message by clearing the anchor element and message state.
  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedMessage(null);
  };

  // Fetches a list of users based on the search term, handles the response, and updates the user list state.
  const getUserList = async (searchTerm) => {
    setCustomerLoader(true);
    const response = await _Client_Center_List(searchTerm);
    if (response.code === 200) {
      setCustomerLoader(false);
      setUserList(response?.customer_list);
    } else {
      setCustomerLoader(false);
      enqueueSnackbar(response.message, {
        variant: "error",
      });
    }
  };

  // Calls the getUserList function to fetch the user list based on the search term entered by the user.
  const handleSearch = () => {
    getUserList(searchTerm);
  };

  // Fetches and formats a list of chats based on the provided parameters (e.g., is_end, searchTerm).
  // It also processes chat participants and their last message details.
  // If a new message is detected and not skipped, it triggers actions to handle the chat selection and notifications.
  const getChatList = async (is_end, searchTerm, skipNewMessage = false) => {
    setLoading(true);
    const response = await _List_Chat(is_end, searchTerm);
    if (response.code === 200) {
      const formattedChats = response.chat_list.map((chat) => {
        const otherParticipant = chat?.participant?.find((p) => p.type !== 0);
        const forCount = chat?.participant?.find((p) => p.type === 0);

        return {
          ...chat,
          id: chat._id,
          receiver_id: chat?.otherParticipant?.receiver_id,
          sender_id: chat?.otherParticipant?.sender_id,
          is_online: otherParticipant?.is_online,
          user_id: otherParticipant?.user_id,
          email: otherParticipant?.email || "Unknown",
          name: `${otherParticipant?.first_name || "Unknown"} ${
            otherParticipant?.last_name || ""
          }`,
          image: otherParticipant?.profile_image
            ? picBaseUrl + otherParticipant?.profile_image
            : "https://www.w3schools.com/howto/img_avatar.png",
          time: chat.chat_date_time
            ? moment(chat.chat_date_time).format("DD-MM-YYYY hh:mm A")
            : "N/A",
          lastMessage: chat.last_message?.message_content || "No messages yet",
          lastMessageTime: moment(chat?.last_message?.message_date_time).format(
            "DD-MM-YYYY hh:mm A"
          ),
          unread: forCount?.unread_message_count > 0,
        };
      });
      if (is_end) {
        setChatList(formattedChats);
        setEndChat(formattedChats);
      } else {
        if (isNewMessage && !skipNewMessage) {
          const finder = formattedChats.find((chat) => {
            if (chat.id === notificationMessage.chat_id) {
              return {
                ...chat,
                name: `${chat?.name}`,
                image: chat?.profile_image
                  ? picBaseUrl + chat?.profile_image
                  : "https://www.w3schools.com/howto/img_avatar.png",
              };
            } else {
              return false;
            }
          });
          !finder &&
            enqueueSnackbar("The chat you were looking for has ended.", {
              variant: "error",
            });
          finder && setIsChatSelected(true);
          finder && handleClickChat(finder, true);
        }
        setChatList(formattedChats);
        setChats(formattedChats);
      }
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, {
        variant: "error",
      });
    }
  };

  //  This function handles the chat selection process by fetching messages,
  // - managing chat data, and updating the UI based on the current tab or message existence.
  const handleClickChat = async (chats, isNewMessage = false) => {
    setSelectChat((prev) => {
      return {
        ...prev,
        is_online: chats?.is_online,
        name: chats?.name || chats?.first_name + " " + chats?.last_name,
        ...chats,
      };
    });
    setChatLoader(true);

    if (tabValue === 1) {
      const messagesResponse = await _List_Chat_Messages(chats?._id);
      if (messagesResponse.code === 200) {
        setSelectChat((prev) => {
          return {
            ...prev,
            ...messagesResponse?.chat,
            messages: messagesResponse?.message_list,
          };
        });
        setChatLoader(false);
      } else {
        setChatLoader(false);
        enqueueSnackbar(messagesResponse.message, {
          variant: "error",
        });
      }
    } else {
      const response = await _Exiting_Messages(chats?.user_id);
      if (response.code === 200) {
        if (response?.is_chat_exist) {
          setIsChatInitiated(true);
          const messagesResponse = await _List_Chat_Messages(
            response?.chat?._id
          );
          if (messagesResponse.code === 200) {
            const forCount = response?.chat?.participant?.find(
              (p) => p.type === 0
            );
            setUnreadMessageCount((prev) => {
              if (!isNewMessage) {
                if (forCount?.unread_message_count > 0) {
                  return prev - forCount?.unread_message_count;
                } else {
                  return prev;
                }
              } else {
                return 0;
              }
            });

            setSelectChat((prev) => {
              return {
                ...prev,
                ...response?.chat,
                ...messagesResponse?.chat,
                messages: messagesResponse?.message_list,
              };
            });
            setChatLoader(false);
          } else {
            setChatLoader(false);
            enqueueSnackbar(response.message, {
              variant: "error",
            });
          }
        } else {
          setIsChatInitiated(false);
          setChatLoader(false);
          setSelectChat((prev) => {
            return {
              ...prev,
              ...response?.chat,
              messages: response?.message_list,
            };
          });
        }
      } else {
        setChatLoader(false);
        enqueueSnackbar(response.message, {
          variant: "error",
        });
      }
    }
  };

  // Opens the delete confirmation for a message.
  const handleDeleteMessage = (item) => {
    setOpenDelete(item);
  };

  // Sets up the message for editing and closes the menu.
  const handleUpdatingMessage = (item) => {
    setEdit(item._id);
    handleCloseMenu();
    setMessage(item.message_content);
  };

  // Sends a new message to the chat via socket and clears the input field.
  const handleSendMessage = (e) => {
    e.preventDefault();
    const newMessage = {
      receiver_id: selectChat?.user_id,
      message_content_type: "general",
      message_content: messages,
      x_sh_auth: localStorage.getItem("token"),
    };
    socket.emit("send_chat_message", newMessage);
    setMessage(""); // Clear input after send
    setSendMessagesLoader(true);
  };

  // Edits an existing message and sends the updated content via socket.
  const handleEditMessage = (e) => {
    e.preventDefault();
    const prevMessages = {
      message_id: edit,
      message_content: messages,
    };
    socket.emit("update_chat_message", prevMessages);
    setEdit(null);
    setMessage("");
    setSendMessagesLoader(true);
    setMessageId(edit);
  };

  // Creates a clickable link that opens in a new tab with security features.
  const linkDecorator = (href) => {
    // Remove "mailto:" if it's included in the href and show the plain email
    const cleanHref = href.replace(/^mailto:/, "");

    return (
      <a href={`mailto:${cleanHref}`} target="_blank" rel="noopener noreferrer">
        {cleanHref} {/* Display the email without 'mailto:' */}
      </a>
    );
  };

  // Resets the unread message count for a specific chat to zero and refreshes the chat list.
  const makeChatCountZero = async (id) => {
    setBackButtonLoader(true);
    const ZeroResponse = await _Make_Count_Zero(id);
    if (ZeroResponse.code === 200) {
      if (tabValue === 0) {
        getChatList(false, "", true);
      } else if (tabValue === 1) {
        getChatList(true);
      } else {
        getUserList("");
      }
      setChatList((prev) => {
        return prev.map((item) => {
          if (item._id === id) {
            return {
              ...item,
              unread: 0,
            };
          }
          return item;
        });
      });
    }
    setIsChatSelected(false);
    setBackButtonLoader(false);
  };

  // Scrolls to the bottom of the chat whenever new messages are received or a message is being sent.
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [selectChat?.messages, sendMessagesLoader]);

  useEffect(() => {
    getChatList(false);
  }, []);

  return (
    <div className="live-chat-container">
      <DeleteConfirmation
        open={openDelete}
        isLoading={delLoading}
        handleClose={() => setOpenDelete(false)}
        setOpen={setOpenDelete}
        title={"Are you sure you want to delete this Message?"}
        handleAgree={() => {
          setDelLoading(true);
          socket.emit("delete_chat_message", {
            chat_id: selectChat._id,
            message_id: openDelete._id,
          });
        }}
      />
      <div className={`chat-popup ${open ? "fade-in-slide" : "fade-out"}`}>
        <div className="chat-header">
          {isChatSelected ? (
            <>
              <div className="col-12 col-md-8 d-flex align-items-center">
                <div
                  style={{
                    position: "relative",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ArrowBackIosIcon
                    onClick={() => {
                      if (!backButtonLoader) {
                        makeChatCountZero(selectChat._id);
                        setSearchTerm("");
                        setisNewMessage(false);
                      }
                    }}
                    style={{
                      cursor: backButtonLoader ? "not-allowed" : "pointer",
                      fontSize: "20px",
                      fontWeight: "bold",
                      opacity: backButtonLoader ? 0.5 : 1,
                    }}
                  />
                </div>
                &nbsp;&nbsp;
                <div className="position-relative">
                  <img
                    src={selectChat?.image}
                    alt={"asds"}
                    height={40}
                    width={40}
                    className="rounded-circle"
                  />
                  {tabValue !== 1 && (
                    <span
                      className="status-indicator position-absolute top-0 start-0 "
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        border: "2px solid white",
                        background: selectChat?.is_online
                          ? "#28a745"
                          : "#6c757d",
                      }}
                    />
                  )}
                </div>
                &nbsp;&nbsp;
                <div>
                  <span>{show_proper_words(selectChat?.name)}</span>
                  <p
                    className="mb-0"
                    style={{
                      opacity: 0.5,
                      fontSize: 12,
                    }}
                  >
                    {selectChat?.email}
                  </p>
                </div>
              </div>
              {(tabValue === 0 || tabValue === 2) &&
                !selectChat?.is_end &&
                !chatLoader &&
                isChatInitiated && (
                  <div className="col-12 col-md-4 mt-3 mt-md-0 d-flex justify-content-end">
                    <div
                      className=" end_chat pointer"
                      onClick={(e) => {
                        const objectTosend = {
                          chat_id: selectChat?._id,
                          user_id: selectChat?.user_id,
                        };

                        // console.log("end chat", objectTosend);

                        socket.emit("end_chat", objectTosend);
                      }}
                    >
                      Chat End
                    </div>
                  </div>
                )}
            </>
          ) : (
            <>
              <span>Live Chat Support</span>
              <div onClick={handleClose}>
                <CloseIcon
                  style={{
                    cursor: "pointer",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                />
              </div>
            </>
          )}
        </div>
        {isChatSelected ? (
          <>
            {chatLoader ? (
              <div className="height_500 d-flex justify-content-center align-items-center">
                <CircularProgress style={{ color: "white" }} />
              </div>
            ) : (
              <div className="chat-body p-3">
                {selectChat?.messages?.length > 0 ? (
                  selectChat?.messages?.map((item, index) => {
                    const Message = item._id === messageId;

                    return (
                      <>
                        {Message && sendMessagesLoader ? (
                          <>
                            <div className="mb-2 d-flex justify-content-end col-12">
                              <Skeleton
                                variant="rectangular"
                                width={120}
                                height={32}
                                animation="wave"
                                sx={{ borderRadius: "4px" }}
                              />
                            </div>
                            <div className="mb-2 d-flex justify-content-end col-12">
                              <Skeleton
                                variant="rectangular"
                                width={80}
                                height={12}
                                animation="wave"
                                sx={{ borderRadius: "2px" }}
                              />
                            </div>
                          </>
                        ) : (
                          <div key={index} className="mb-2 position-relative">
                            <>
                              <p
                                className={`chat_message mb-1 ${
                                  item.sender_id === selectChat?.user_id
                                    ? "bot"
                                    : "user"
                                }`}
                              >
                                <Linkify componentDecorator={linkDecorator}>
                                  {item.message_content}
                                </Linkify>
                              </p>

                              {/* More Vert Icon for Dropdown */}
                              <div
                                className="position-absolute"
                                style={{
                                  top: "0px",
                                  left:
                                    item.sender_id === selectChat?.user_id
                                      ? "-25px"
                                      : "98%",
                                }}
                              >
                                {item.sender_id !== selectChat?.user_id &&
                                  !selectChat?.is_end && (
                                    <IconButton
                                      onClick={(e) => handleClick(e, item)}
                                      className="ms-2"
                                      style={{
                                        fontSize: "14px",
                                        width: "14px",
                                        height: "14px",
                                      }}
                                    >
                                      <MoreVertIcon
                                        sx={{
                                          fontSize: "14px !important",
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                              </div>

                              {/* MUI Menu for the dropdown */}
                              <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleCloseMenu}
                                sx={{
                                  zIndex: 999999,
                                  "& .MuiPaper-root": {
                                    backgroundColor: "#343a40",
                                    color: "#fff",
                                  },
                                  "& .MuiMenuItem-root:hover": {
                                    backgroundColor: "#495057",
                                  },
                                }}
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                              >
                                <MenuItem
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleUpdatingMessage(selectedMessage);
                                    handleCloseMenu();
                                  }}
                                >
                                  Edit
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    setIsDelete(true);
                                    handleDeleteMessage(selectedMessage);
                                    handleCloseMenu();
                                  }}
                                >
                                  Delete
                                </MenuItem>
                              </Menu>

                              <p
                                className={`chat_time ${
                                  item.sender_id === selectChat?.user_id
                                    ? ""
                                    : "ms-auto"
                                }`}
                              >
                                {moment(item?.message_date_time).format(
                                  "DD-MM-YYYY hh:mm A"
                                )}
                              </p>
                            </>
                          </div>
                        )}
                      </>
                    );
                  })
                ) : (
                  <div className="d-flex flex-column align-items-center justify-content-center text-muted mt-5">
                    <div className="text-center">
                      <Icon
                        icon="mdi:chat"
                        className="fs-3"
                        style={{ color: "#868e96" }}
                      />
                      <h5 className="mt-3">No Messages Yet</h5>
                      <p className="text-secondary">
                        This conversation is empty. Start a conversation to
                        begin chatting.
                      </p>
                    </div>
                  </div>
                )}
                {sendMessagesLoader && !messageId && (
                  <>
                    <div className="mb-2 d-flex justify-content-end col-12">
                      <Skeleton
                        variant="rectangular"
                        width={120}
                        height={32}
                        animation="wave"
                        sx={{ borderRadius: "4px" }}
                      />
                    </div>
                    <div className="mb-2 d-flex justify-content-end col-12">
                      <Skeleton
                        variant="rectangular"
                        width={80}
                        height={12}
                        animation="wave"
                        sx={{ borderRadius: "2px" }}
                      />
                    </div>
                  </>
                )}
                <div ref={chatEndRef} />
              </div>
            )}
            <form
              onSubmit={(e) => {
                if (messages?.trim() === "") {
                  e.preventDefault();
                  enqueueSnackbar("Please enter a message", {
                    variant: "warning",
                  });
                  return;
                } else {
                  if (edit) {
                    handleEditMessage(e);
                  } else {
                    handleSendMessage(e);
                  }
                }
              }}
            >
              <div className="chat-footer justify-content-center">
                {tabValue === 1 || selectChat?.is_end ? (
                  <p>Your conversation has ended</p>
                ) : (
                  <>
                    <input
                      type="text"
                      required
                      placeholder="Type a message..."
                      className="form-control"
                      name="messages"
                      value={messages}
                      onChange={(e) => setMessage(e.target.value)}
                      onBlur={() => {
                        // Trim spaces when the user leaves the input field
                        setMessage(messages.trim());
                      }}
                    />
                    <button
                      type="submit"
                      role="submit"
                      tabIndex="0"
                      className="small-contained-button"
                      disabled={sendMessagesLoader || chatLoader}
                    >
                      {edit ? "Edit" : "Send"}
                    </button>
                  </>
                )}
              </div>
            </form>
          </>
        ) : (
          <>
            {tabValue === 2 ? (
              <>
                {customerLoader ? (
                  <div className="height_500 d-flex justify-content-center align-items-center">
                    <CircularProgress />
                  </div>
                ) : (
                  <>
                    {/* Search Bar */}

                    <div className="chat-body height_500">
                      <div className="p-3 d-flex">
                        <input
                          type="text"
                          className="form-control me-2"
                          placeholder="Search Customer by name..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button
                          className=" small-contained-button"
                          onClick={handleSearch}
                        >
                          Search
                        </button>
                      </div>
                      <div className="chat-list">
                        {userList?.length === 0 ? (
                          <div className="mt-5">
                            <div className="d-flex justify-content-center">
                              <Icon
                                icon="bx:bx-user-x"
                                style={{ fontSize: "24px", marginRight: "8px" }}
                              />
                            </div>
                            <div className="text-center">
                              <span>No users found</span>
                            </div>
                          </div>
                        ) : (
                          userList.map((chat, index) => (
                            <div
                              onClick={() => {
                                setIsChatSelected(true);
                                setSelectChat({
                                  ...chat,
                                  name: `${chat?.name}`,
                                  image: chat?.profile_image
                                    ? picBaseUrl + chat?.profile_image
                                    : "https://www.w3schools.com/howto/img_avatar.png",
                                });
                                handleClickChat(chat);
                              }}
                              key={index}
                              className={`chat-item d-flex align-items-center p-3 ${
                                chat?.unread ? "bg_white" : "bg_light"
                              }`}
                            >
                              <div className="position-relative">
                                <img
                                  src={
                                    chat?.profile_image
                                      ? picBaseUrl + chat.profile_image
                                      : "https://www.w3schools.com/howto/img_avatar.png"
                                  }
                                  className="chat-avatar rounded-circle"
                                />
                                {tabValue !== 1 && (
                                  <span
                                    className="status-indicator position-absolute top-0 start-0 "
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      borderRadius: "50%",
                                      border: "2px solid white",
                                      background: chat?.is_online
                                        ? "#28a745"
                                        : "#6c757d",
                                    }}
                                  />
                                )}
                              </div>

                              <div className="flex-grow-1 ms-3">
                                <div className="d-flex justify-content-between">
                                  <strong className="chat-name">
                                    {show_proper_words(
                                      chat?.first_name + " " + chat?.last_name
                                    )}
                                  </strong>
                                  <span className="chat-time text-muted small">
                                    {chat?.time}
                                  </span>
                                </div>
                                <p className="chat-message text-muted mb-0">
                                  {chat?.email}
                                </p>
                              </div>
                              {chat?.unread && (
                                <span className="unread-indicator"></span>
                              )}
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : tabValue === 0 ? (
              <>
                {loading ? (
                  <div className="height_500 d-flex justify-content-center align-items-center">
                    <CircularProgress />
                  </div>
                ) : (
                  <div className="chat-body height_500">
                    <div className="p-3 d-flex">
                      <input
                        type="text"
                        className="form-control me-2"
                        placeholder="Search chats by customer name..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <button
                        className=" small-contained-button"
                        onClick={() => {
                          getChatList(false, searchTerm);
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="chat-list">
                      {chatList?.length === 0 ? (
                        <div
                          className="d-flex justify-content-center align-items-center flex-column"
                          style={{ height: "350px" }}
                        >
                          <div className="text-center">
                            <Icon
                              icon="mynaui:chat-x-solid"
                              style={{
                                fontSize: "48px",
                                marginBottom: "12px",
                                color: "#868e96",
                              }}
                            />
                            <div>
                              <span className="text-muted">No Chats Found</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          {" "}
                          {chatList?.map((chat, index) => (
                            <div
                              onClick={() => {
                                setIsChatSelected(true);
                                setSelectChat({
                                  ...chat,
                                  name: `${chat?.first_name} ${chat?.last_name}`,
                                  image: chat?.profile_image
                                    ? picBaseUrl + chat?.profile_image
                                    : "https://www.w3schools.com/howto/img_avatar.png",
                                });
                                handleClickChat(chat);
                              }}
                              key={index}
                              className={`chat-item d-flex align-items-center p-3 ${
                                chat.unread ? "bg_white" : "bg_light"
                              }`}
                            >
                              <div className="position-relative">
                                <img
                                  src={chat.image}
                                  alt={chat.name}
                                  className="chat-avatar rounded-circle"
                                />
                                <span
                                  className="status-indicator position-absolute top-0 start-0 "
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    borderRadius: "50%",
                                    border: "2px solid white",
                                    background: chat?.is_online
                                      ? "#28a745"
                                      : "#6c757d",
                                  }}
                                />
                              </div>

                              <div className="flex-grow-1 ms-3">
                                <div className="d-flex justify-content-between">
                                  <strong className="chat-name capitalized">
                                    {chat.name}
                                  </strong>
                                  <span className="chat-time text-muted small">
                                    {chat.lastMessageTime}
                                  </span>
                                </div>
                                <p className="chat-message text-muted mb-0">
                                  {chat.lastMessage?.length > 30
                                    ? chat.lastMessage.slice(0, 30) + "..."
                                    : chat.lastMessage}
                                </p>
                              </div>
                              {chat.unread && (
                                <span className="unread-indicator"></span>
                              )}
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </>
            ) : tabValue === 1 ? (
              <>
                {loading ? (
                  <div className="height_500 d-flex justify-content-center align-items-center">
                    <CircularProgress />
                  </div>
                ) : chatList?.length === 0 ? ( // Check if chatList is empty
                  <div className="height_500 d-flex justify-content-center align-items-center text-muted">
                    No chats available
                  </div>
                ) : (
                  <div className="chat-body height_500">
                    <div className="p-3 d-flex">
                      <input
                        type="text"
                        className="form-control me-2"
                        placeholder="Search ended chats by name..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <button
                        className=" small-contained-button"
                        onClick={() => {
                          getChatList(true, searchTerm);
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div className="chat-list">
                      {chatList?.map((chat, index) => (
                        <div
                          onClick={() => {
                            setIsChatSelected(true);
                            setSelectChat({
                              ...chat,
                              name: `${chat?.first_name} ${chat?.last_name}`,
                              image: chat?.profile_image
                                ? picBaseUrl + chat?.profile_image
                                : "https://www.w3schools.com/howto/img_avatar.png",
                            });
                            handleClickChat(chat);
                          }}
                          key={index}
                          className={`chat-item d-flex align-items-center p-3 ${
                            chat.unread ? "bg_white" : "bg_light"
                          }`}
                        >
                          <img
                            src={chat.image}
                            alt={chat.name}
                            className="chat-avatar rounded-circle"
                          />

                          <div className="flex-grow-1 ms-3">
                            <div className="d-flex justify-content-between">
                              <strong className="chat-name capitalized">
                                {chat.name}
                              </strong>
                              <span className="chat-time text-muted small">
                                {chat.time}
                              </span>
                            </div>
                            <p className="chat-message text-muted mb-0">
                              {chat.lastMessage?.length > 30
                                ? chat.lastMessage.slice(0, 30) + "..."
                                : chat.lastMessage}
                            </p>
                          </div>
                          {chat.unread && (
                            <span className="unread-indicator"></span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            ) : null}
            <div className="chat-footer justify-content-evenly align-items-center ">
              <div
                className="text-center pointer"
                onClick={() => {
                  if (!loading) {
                    setSearchTerm("");
                    setTabValue(0);
                    getChatList(false);
                  }
                }}
              >
                <GiteOutlinedIcon
                  style={{
                    fontSize: 25,
                    fill: tabValue === 0 ? "#6d00fc" : "#fff",
                  }}
                />
                <p
                  style={{
                    color: tabValue === 0 ? "#6d00fc" : "#fff",
                  }}
                  className="m-0 fs-14"
                >
                  Home
                </p>
              </div>
              <div
                className="text-center pointer"
                onClick={() => {
                  if (!loading) {
                    getChatList(true);
                    setTabValue(1);
                    setSearchTerm("");
                  }
                }}
              >
                <HistoryOutlinedIcon
                  style={{
                    fontSize: 25,
                    fill: tabValue === 1 ? "#6d00fc" : "#fff",
                  }}
                />
                <p
                  style={{
                    color: tabValue === 1 ? "#6d00fc" : "#fff",
                  }}
                  className="m-0 fs-14"
                >
                  History
                </p>
              </div>
              <div
                className="text-center pointer"
                onClick={() => {
                  if (!loading) {
                    getUserList();
                    setTabValue(2);
                    setSearchTerm("");
                  }
                }}
              >
                <GroupIcon
                  style={{
                    fontSize: 25,
                    fill: tabValue === 2 ? "#6d00fc" : "#fff",
                  }}
                />
                <p
                  style={{
                    color: tabValue === 2 ? "#6d00fc" : "#fff",
                  }}
                  className="m-0 fs-14"
                >
                  Customers
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
